/**
 * Generic function to handle navigation selection from an array of options
 * @param options Array of options with value and route properties
 * @param selectedIndex The selected index/value
 * @param navigate Navigation function
 * @param setIsSelecting State setter for selection status
 * @param onBefore Optional callback to run before navigation
 */
export const handleOptionSelect = async <T extends { value: number; route: string }>(
    options: T[],
    selectedIndex: number,
    navigate: (path: string) => void,
    isSelecting: boolean,
    setIsSelecting: (isSelecting: boolean) => void,
    onBefore?: () => void
  ): Promise<void> => {
    if (isSelecting) return;
    setIsSelecting(true);
    
    // Run optional callback before navigation (like logging)
    if (onBefore) {
      onBefore();
    }
    
    // Find and navigate to the selected option
    const selectedOption = options.find(option => option.value === selectedIndex);
    if (selectedOption) {
      navigate(selectedOption.route);
    }
    
    setIsSelecting(false);
  };